import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import SelectDepartment from '@Components/Common/SelectDepartment';
import UserActions from '@Actions/userActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { Select } from 'antd';
import './style.scss';
import PRZSelect from '../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
class UpdateUser extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      name: '',
      roleList: [],
      departmentsList: ['Admin', 'Finance', 'Purchase', 'Operations', 'Guest', 'Others'],
    };
  }

  /**
   *
   */
  componentDidMount() {
    const {
      getRoles, selectedUser, selectedTenant, user,
    } = this.props;
    getRoles(selectedTenant?.tenant_id ? selectedTenant?.tenant_id : user?.tenant_info?.tenant_id);
    this.setState({
      email: selectedUser.username,
      name: `${selectedUser?.first_name ? selectedUser?.first_name : ''} ${selectedUser?.last_name ? selectedUser?.last_name : ''}`,
      phone: selectedUser.mobile,
      userId: selectedUser.user_id,
      department: selectedUser?.tenant_department_info?.department_id,
      role: selectedUser?.tenant_role_id,
      designation: selectedUser.designation,
    });
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    if (props?.roles?.data && !state.roleList?.length) {
      const roleMapping = {};
      for (let i = 0; i < props?.roles?.data?.length; i++) {
        const currentRole = props?.roles?.data[i];
        // eslint-disable-next-line max-len
        if (roleMapping.hasOwnProperty(props?.roles?.data[i]?.tenant_department_name.toUpperCase())) roleMapping[props?.roles?.data[i]?.tenant_department_name.toUpperCase()].push(currentRole);
        else roleMapping[props?.roles?.data[i]?.tenant_department_name.toUpperCase()] = [currentRole];
      }
      return {
        ...state,
        roleList: roleMapping,
      };
    }
    return state;
  }

  /**
   *
   */
   updateUser = () => {
     this.setState({ formSubmitted: true });
     const {
       email, name, roleId, role, phone, userId, designation, department,
     } = this.state;
     const {
       updateUser, callback, user, selectedTenant,
     } = this.props;
     if (role && email && name) {
       const payload = {
         email,
         first_name: name,
         mobile: phone?.toString(),
         tenant_id: selectedTenant?.tenant_id || user?.tenant_info?.tenant_id,
         tenant_role_id: role,
         user_id: userId,
         designation,
         department,
       };
       updateUser([payload], () => callback());
     }
   }

   /**
    *
    * @return {JSX.Element}
    */
   render() {
     const {
       updateUserLoading, getRoles, selectedTenant, user, roles,
     } = this.props;
     const {
       name, formSubmitted, email, phone, department, role, designation,
     } = this.state;

     return (
       <div className="ant-row">
         <div className="ant-col-md-24 ant-col-xs-24">
           <H3FormInput
             name="Name"
             type="text"
             containerClassName="orgInputContainer"
             labelClassName="orgFormLabel"
             inputClassName="gst__input-add-product orgFormInput"
             value={name}
             label="Name"
             required
             showError={formSubmitted && !(name)}
             maxlength="50"
             disabled
           />
         </div>
         <div className="ant-col-md-24 ant-col-xs-24">
           <H3FormInput
             name="Email"
             type="text"
             containerClassName="orgInputContainer"
             labelClassName="orgFormLabel"
             inputClassName="gst__input-add-product orgFormInput"
             value={email}
             required
             showError={formSubmitted && !(email)}
             label="Email"
             disabled
           />
         </div>
         <div className="ant-col-md-24 ant-col-xs-24">
           <H3FormInput
             name="phone"
             type="text"
             containerClassName="orgInputContainer"
             labelClassName="orgFormLabel"
             inputClassName="gst__input-add-product orgFormInput"
             value={phone}
             required
             showError={formSubmitted && !(phone)}
             label="Phone"
             disabled
           />
         </div>
         <div className="ant-col-md-24 ant-col-xs-24">
           <div className="orgInputContainer">
             <SelectDepartment
               dropdownAlign={{ offset: [-6, 4] }}
               selectedDepartment={department}
               showSearch
               onChange={(value) => {
                 this.setState({ department: value?.department_id, role: '', roleId: '' });
                 getRoles(selectedTenant?.tenant_id ? selectedTenant?.tenant_id : user?.tenant_info?.tenant_id, value?.tenant_department_id);
               }}
               tenantId={selectedTenant?.tenant_id ? selectedTenant?.tenant_id : user?.tenant_info?.tenant_id}
               labelClassName="orgFormLabel"
               inputClassName="orgInputContainer"
             />
             {formSubmitted && !department && (
               <div className="input-error">
                 *Please select
                 department
               </div>
             )}

           </div>
         </div>
         <div className="ant-col-md-24 ant-col-xs-24">
           <div className="orgInputContainer">
             <div style={{ display: 'flex' }}>
               <label style={{ width: '82%' }} className="orgFormLabel">
                 Select Role
                 <span style={{ color: 'red' }}>{'  *'}</span>
               </label>
             </div>
             <PRZSelect
               dropdownAlign={{ offset: [-6, 4] }}
               value={role}
               showSearch
               disabled={!department}
               onChange={(selectedRole) => {
                 this.setState({ role: selectedRole });
               }}
               showError={formSubmitted && !role}
               errorName="Please enter role"
               errorClassName="input-error"
             >
               {roles?.data?.length && roles?.data?.map((item) => (
                 <Option key={item.tenant_role_id} value={item.tenant_role_id}>
                   {item.tenant_role_name}
                 </Option>
               )) }
             </PRZSelect>
           </div>
         </div>
         <div className="ant-col-md-24 ant-col-xs-24">
           <H3FormInput
             name="Designation"
             type="text"
             containerClassName="orgInputContainer"
             labelClassName="orgFormLabel"
             inputClassName="gst__input-add-product orgFormInput"
             placeholder=""
             onChange={(event) => this.setState(
               { designation: event.target.value },
             )}
             value={designation}
             label="Designation"
           />
         </div>
         <div className="ant-col-md-12" style={{ marginTop: '0.5rem' }}>
           <H3Button
             buttonType={defaultButtonTypes.BLUE_ROUNDED}
             text="Update User"
             onClick={() => this.updateUser()}
             isLoading={updateUserLoading}
             disabled={updateUserLoading}
             style={{
               width: '200px',
               borderRadius: '5px',
               padding: '7px 15px',
               marginLeft: '0',
             }}
           />
         </div>
       </div>

     );
   }
}

const mapStateToProps = ({
  UserReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  roles: UserReducers.roles,
  createUserLoading: UserReducers.createUserLoading,
  updateUserLoading: UserReducers.updateUserLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getRoles: (tenantId, tenantDepartmentId) => dispatch(UserActions.getRoles(tenantId, tenantDepartmentId)),
  updateUser: (payload, callback) => dispatch(UserActions.updateUser(payload, callback)),
});

UpdateUser.propTypes = {
  user: PropTypes.any,
  selectedTenant: PropTypes.any,
  callback: PropTypes.any,
  roles: PropTypes.any,
  updateUser: PropTypes.func,
  updateUserLoading: PropTypes.bool,
  selectedUser: PropTypes.any,
  getRoles: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UpdateUser));
